// src/screens/mypage/ReplyToReviewScreen.js
// 72차 신규: 매장관리자 알림 탭에서 "새 리뷰" 알림을 누르면 해당 리뷰로 바로 이동해
// 답글을 달 수 있는 화면. ReviewCard.js의 기존 adminUid 답변 UI(36차)를 그대로 재사용하고,
// getReplyTemplate()로 매장/지점명이 들어간 기본 인사말을 답변 입력창에 미리 채워준다.
// 75차: 자체 커스텀 헤더 → 공통 AppHeader로 교체(다른 화면과 동일 패턴 누락분)
import React, { useState, useEffect, useCallback } from 'react';
import { View, Text, StyleSheet, ScrollView, ActivityIndicator } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';
import { useAuth } from '../../contexts/AuthContext';
import { getReviewById, getReplyTemplate } from '../../services/reviewService';
import { parseProductId } from '../../services/productService';
import { ReviewCard } from '../../components/common/ReviewCard';
import AppHeader from '../../components/common/AppHeader';
import { COLORS } from '../../constants/theme';

const GOLD = COLORS.gold, BG = COLORS.bg;
const TEXT = COLORS.text, TEXT_MUTED = COLORS.textMuted;

export default function ReplyToReviewScreen({ navigation, route }) {
  const insets = useSafeAreaInsets();
  const { user } = useAuth();
  const { reviewId } = route.params || {};

  const [review,  setReview]  = useState(null);
  const [store,   setStore]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  const load = useCallback(async () => {
    if (!reviewId) { setNotFound(true); setLoading(false); return; }
    try {
      const rv = await getReviewById(reviewId);
      if (!rv) { setNotFound(true); return; }
      setReview(rv);
      const storeId = rv.storeId || parseProductId(rv.productId)?.storeId;
      if (storeId) {
        const snap = await getDoc(doc(db, 'stores', storeId));
        if (snap.exists()) setStore({ id: storeId, ...snap.data() });
      }
    } catch {
      setNotFound(true);
    } finally { setLoading(false); }
  }, [reviewId]);

  useEffect(() => { load(); }, [load]);

  return (
    <View style={s.container}>
      <AppHeader showBack centerElement={<Text style={s.headerTitle}>리뷰 답글</Text>} />

      {loading ? (
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
          <ActivityIndicator size="large" color={GOLD} />
        </View>
      ) : notFound || !review ? (
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', padding: 32 }}>
          <Text style={{ color: TEXT_MUTED, textAlign: 'center' }}>
            리뷰를 찾을 수 없어요. 삭제되었을 수 있어요.
          </Text>
        </View>
      ) : (
        <ScrollView contentContainerStyle={{ padding: 16, paddingBottom: insets.bottom + 32 }}>
          <ReviewCard
            review={review}
            adminUid={user?.uid}
            onReplyChanged={(updated) => setReview(updated)}
            replyTemplate={(r) => getReplyTemplate(store, r)}
          />
        </ScrollView>
      )}
    </View>
  );
}

const s = StyleSheet.create({
  container:   { flex: 1, backgroundColor: BG },
  headerTitle: { color: TEXT, fontSize: 15, fontWeight: '800' },
});
